// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4528":"06f6f90a","7278":"22965ec7","8949":"22965ec7","9662":"06f6f90a","9670":"22965ec7"}[chunkId] + ".chunk.css";
};